<template lang="pug">
  div
    a(
      :href="value.url_answer"
      target="_blank"
    ) {{ answerData.url_answer }}

</template>

<script>
export default {
  name: 'TypeLink',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
